export enum Event {
    SelfieVerificationDone = "web:apply:documents:selfie:complete",
}

type PayloadForEvent<TEvent extends Event> = {
    [Event.SelfieVerificationDone]: {
        jobId: string;
        status: string;
        success: boolean;
        errors: Array<{ type: string; message: string }>;
    };
}[TEvent];

export function logEvent<TEvent extends Event>(event: TEvent, payload: PayloadForEvent<TEvent>): void {
    window?.analytics?.track(event, payload);
}
